export const testConfig = {
  API: {
    ROOT_URL: () => 'https://etapi.econsulttest.health',
  },
  S3_BUCKET: `https://s3.eu-west-2.amazonaws.com/test-etriage.frontend.econsult.health/econsult-frontend/${process.env.REACT_APP_VERSION}/build`,
  SESSION_TIMEOUT: {
    IN_MINUTES: 20,
  },
  PREFILL_ENABLED: true,
  PREFILL_CLINICAL_REVIEW_ONLY: true,
  PREFILL_DATA: {
    FIRSTNAME: 'ETRIAGETEST9730582459',
    SURNAME: 'ZZZTEST',
    SEX: 'Female',
    GENDER: 'Female',
    TELEPHONE: '07977777777',
    DATE_OF_BIRTH_ADULT: 'DATE_OF_BIRTH_ADULT',
    DATE_OF_BIRTH_PAED: 'DATE_OF_BIRTH_PAED',
    ADDRESS: '4 Barons Court Road',
    CITY: 'London',
    POSTCODE: 'KT1 2SY',
    TITLE: 'Ms',
    CHILD_TITLE: 'Miss',
    MARITAL_STATUS: 'Single',
    CHILD_MARITAL_STATUS: 'Unmarried',
  },
};
